import React, { Component } from 'react';


class XH2 extends Component{

    constructor(props) {
        super(props)
        this.props=props;
    }

    render(){
        return(
            <>
                <h2 className={this.props.class} id={this.props.id} >
                    {this.props.children}
                </h2>
            </>
        )
    }
}


export default  XH2;

